import { render, staticRenderFns } from "./load-rating-product.vue?vue&type=template&id=e3610190"
import script from "./load-rating-product.vue?vue&type=script&lang=js"
export * from "./load-rating-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports